// 使用路由(路由守卫)
import router from './index'
// 判断是否登录，需要拿到token,所以引入vuex
import store from '@/store'
// 定义白名单，不需要token(登录)也可以进入的页面
const whiteList = ['/']
// let registerRouteFresh = true
// 路由守卫
router.beforeEach(async (to, from, next) => {
  console.log(to)
  document.title = to.meta.title ? '平台' : '管理平台'
  if (to.fullPath !== '/' && store.getters.token) {
    if (store.getters.registerRouteFresh) {
      try {
        await store.dispatch('app/getMenuList')
        store.getters.routerList.forEach((value, index) => {
          router.addRoute(value)
        })
      } catch (e) {
        console.error(e)
        // @ts-ignore
        store.dispatch('app/logout')
      }
      next({
        ...to,
        replace: true
      })
      store.commit('app/setRegisterRouteFresh', false)
    } else {
      next()
    }
  } else {
    // 没有token
    // 如果在白名单，继续操作
    if (whiteList.includes(to.path) && store.getters.token) {
      next('/home')
    } else if (whiteList.includes(to.path)) {
      next()
    } else {
      // 没有在白名单，则跳转到登陆页面
      next('/')
    }
  }
})
